import React from 'react';

export default function MspReadEmpty({ icon = 'bi-clipboard2', message }) {
  return (
    <div className="msp-read-empty">
      <i className={`bi ${icon}`} aria-hidden />
      <p>{message}</p>
    </div>
  );
}
